// This code has been partially generated by an AI.

import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { map, switchMap } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { UUID } from '@app/_api/identifyable';
import { EmployeeViewSwitchService } from '@app/core/services/employee-view-switch.service';

@Component({
  selector: 'if-profile-picture',
  templateUrl: './profile-picture.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe],
})
export class ProfilePictureComponent {
  readonly employee = input.required<{ uuid: UUID; firstname?: string | null; lastname?: string | null }>();
  readonly colorIndex = input<number>(5);
  readonly size = input<'sm' | 'md'>('md');
  readonly quality = input<0 | 4>(0);
  readonly blockEmployeeSwitchDialog = input<boolean>(false);

  protected readonly $initials = computed(() => {
    const employee = this.employee();
    if (!employee) return undefined;
    const firstInitial = employee.firstname?.trim().charAt(0);
    const lastInitial = employee.lastname?.trim().charAt(0);
    const initials = `${firstInitial ?? ''}${lastInitial ?? ''}`.trim();
    return initials.length > 0 ? initials : undefined;
  });

  protected readonly url$ = toObservable(computed(() => ({ employee: this.employee(), quality: this.quality() }))).pipe(
    filter(({ employee }) => !!employee),
    switchMap(({ employee, quality }) => this.employeeDataService.getPictureForEmployee(employee.uuid, quality)),
    map(pictureData =>
      pictureData.picture
        ? this.sanitizer.bypassSecurityTrustResourceUrl(`data:${pictureData.contentType};base64,${pictureData.picture}`)
        : null,
    ),
  );

  private readonly employeeDataService = inject(EmployeeDataService);
  private readonly employeeViewSwitchService = inject(EmployeeViewSwitchService);
  private readonly sanitizer = inject(DomSanitizer);

  getBackgroundColorForIndex(index: number) {
    switch (index) {
      case 0:
        return '#6349B9';
      case 1:
        return '#3E39C3';
      case 2:
        return '#6C88D3';
      case 3:
        return '#BC357C';
      case 4:
        return '#E79AC1';
      case 5:
        return '#DF7436';
      default:
        return '#6349B9';
    }
  }

  onEmployeeClick() {
    if (this.blockEmployeeSwitchDialog()) return;
    const employee = this.employee();
    this.employeeViewSwitchService.switchToEmployee({
      uuid: employee.uuid,
      firstname: employee.firstname ?? '',
      lastname: employee.lastname ?? '',
    });
  }
}
